export default "__VITE_ASSET__e0928579__"